"use strict";

var config = require('../../package.json');
module.exports = /*@ngInject*/function ($resource, ConfigService) {
  var _ConfigService$getCon = ConfigService.getConfig(),
    INSPECT_URL = _ConfigService$getCon.INSPECT_URL;
  var service = $resource("".concat(INSPECT_URL, "/api/platform"), {}, {
    _publishPlatformInfo: {
      method: 'POST',
      url: "".concat(INSPECT_URL, "/api/platform")
    }
  });
  service.publishPlatformInfo = function (device, type) {
    var platformInfo = {
      app: 'INSPECT',
      type: type,
      appVersion: config.version,
      device: {
        uuid: device.uuid,
        model: device.model,
        platform: device.platform,
        version: device.version,
        manufacturer: device.manufacturer
      }
    };
    return service._publishPlatformInfo({}, platformInfo).$promise;
  };
  return service;
};